import React from "react";

export default function footer() {
  return (
    <div>
      <footer>
        <a href="https://www.freepik.com/free-photos-vectors/background">
          Backgrounds vector created by srip, starline and freepik -
          www.freepik.com
        </a>
        <div>The entire project made by Alex Sadowski</div>
        <div>
          Icons made by{" "}
          <a href="https://www.flaticon.com/authors/freepik" title="Freepik">
            {" "}
          </a>
          authors from{" "}
          <a href="https://www.flaticon.com/" title="Flaticon">
            www.flaticon.com
          </a>
        </div>
      </footer>
      ;
    </div>
  );
}
